import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'bytesToSize', standalone: true })
@Injectable({providedIn: 'root'})
export class BytesToSizePipe implements PipeTransform {
	
	transform(bytes) {
		var sizes: Array<any> = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		if (bytes == 0) return '0 Byte';
		var i: any = parseInt("" + (Math.floor(Math.log(bytes) / Math.log(1024))));
		
		return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
	}
	
}